// Mock data for KYo Group frontend. Replace with backend later.

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Get to know us", href: "#about" },
  { label: "KYo Caribbean", href: "#caribbean" },
  { label: "KYo Couriers", href: "#couriers" },
  { label: "ZipExpress", href: "#zip" },
  { label: "KYo.Own", href: "/kyo-own" },
  { label: "Rates", href: "/rates" },
  { label: "FAQ", href: "/faq" },
];

export const services = [
  {
    id: "couriers",
    name: "KYo Couriers",
    badgeVariant: "light",
    description:
      "KYo Couriers offer innovative logistics services to individuals, businesses, and commercial entities seeking to have items shipped from the United States to Jamaica.",
    image:
      "https://images.unsplash.com/photo-1716191300006-ea66bf47e2b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjByb2JvdCUyMGNhcnJ5aW5nJTIwYm94fGVufDB8fHx8MTc4NzUwMTk1OHww&ixlib=rb-4.1.0&q=85",
    imageSide: "right",
    tag: null,
  },
  {
    id: "caribbean",
    name: "KYo Caribbean Logistics",
    badgeVariant: "red",
    description:
      "KYo Caribbean Logistics is a caribbean based, regional B2B and B2C logistics company offering international, fast cargo package delivery services from the United States to selected regional destinations.",
    image:
      "https://images.pexels.com/photos/37284071/pexels-photo-37284071.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageSide: "left",
    tag: null,
  },
  {
    id: "export",
    name: "KYo Export",
    badgeVariant: "navy",
    description:
      "KYo Exports will seek to capitalises on KYO's vast logistics network, Kanal Platform and Software to provide a reverse logistics structure for companies and individuals looking to ship and export from Jamaica to the USA.",
    image:
      "https://images.unsplash.com/photo-1740914994657-f1cdffdc418e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjB3b3JrZXIlMjBwYWxsZXQlMjBqYWNrJTIwZm9ya2xpZnQlMjBib3hlcyUyMHN0b3JhZ2V8ZW58MHx8fHwxNzg4NDkwODA5fDA&ixlib=rb-4.1.0&q=85",
    imageSide: "right",
    tag: "COMING SOON",
  },
  {
    id: "zip",
    name: "ZipExpress",
    badgeVariant: "zip",
    description:
      "ZipExpress is our exclusive team of Last Mile Delivery Drivers And Riders dedicated to ensure that your package reaches you safe and sound. Our delivery application will locate and dispatch packages and cargo to nearby vehicles, while acting as a real-time payment gateway and automated dispatch management for drivers.",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/wingman/70b9ae63-ca0a-43f8-ab15-4547de7e2723/attachments/f020c2474aef43468424d5edf76678f2_Frame 35%402x.jpg",
    imageSide: "left",
    tag: "",
  },
];

export const partners = ["FedEx", "Amazon", "NETFLIX", "Adidas", "AJAS"];

export const footer = {
  columns: [
    {
      title: "Get to Know Us",
      links: ["Investors", "FAQ", "Terms & Conditions", "Privacy Policy"],
    },
    {
      title: "Our Services",
      links: [
        "KYo Couriers",
        "KYo Caribbean Logistics",
        "KYo Export (Coming soon)",
        "Zipexpress Delivery",
      ],
    },
    {
      title: "Developer",
      links: ["API's (Coming soon)", "Documentation (Coming soon)"],
    },
    {
      title: "Innovation",
      links: ["Kanal Platform and Software", "Cyrus Field Technologies"],
    },
  ],
  address: "The Technology Innovation Centre (TIC) building at the University of Technology, Jamaica ",
  copyright: "KYo Group Limited \u00A9 2026. All rights reserved",
  powered: "Powered by: Cyrus Field Technologies",
};
